module.exports = __webpack_public_path__ + "static/img/coupons-card.2dc8e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/collectCustomerInfo/studentDriver/static/coupons-card.png
// module id = 6NVF
// module chunks = 1